import React from "react";
import { Desktop, Mobile } from "@edreamsodigeo/frontend-core";
import { Box, Flex, IsometricMedia } from "@edreamsodigeo/prisma-design-system";
import ManageBookingsBannerAdvantages from "./ManageBookingsBannerAdvantages";
import ManageBookingsBannerHeader from "./ManageBookingsBannerHeader";
const ManageBookingsBanner = () => {
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Desktop, null, /*#__PURE__*/React.createElement(Box, {
    width: "455px",
    minHeight: "635px",
    backgroundColor: "primary.10",
    pt: "1x_huge",
    pl: "3x_big"
  }, /*#__PURE__*/React.createElement(IsometricMedia, {
    size: "xlarge",
    category: "Places",
    name: "Globe"
  }), /*#__PURE__*/React.createElement(ManageBookingsBannerHeader, null), /*#__PURE__*/React.createElement(ManageBookingsBannerAdvantages, null))), /*#__PURE__*/React.createElement(Mobile, null, /*#__PURE__*/React.createElement(Box, {
    backgroundColor: "primary.10"
  }, /*#__PURE__*/React.createElement(Flex, {
    position: "relative",
    p: "big",
    flexDirection: "column",
    gap: "big"
  }, /*#__PURE__*/React.createElement(Box, {
    pr: "2x_huge",
    pt: "1x_small"
  }, /*#__PURE__*/React.createElement(ManageBookingsBannerHeader, null), /*#__PURE__*/React.createElement(Box, {
    position: "absolute",
    right: "base",
    top: "base"
  }, /*#__PURE__*/React.createElement(IsometricMedia, {
    size: "medium",
    category: "Places",
    name: "Globe"
  }))), /*#__PURE__*/React.createElement(ManageBookingsBannerAdvantages, null)))));
};
export default ManageBookingsBanner;